/**
 * Requires
 */

import $ from 'jquery'

/**
 * Constants
 */

const TRANSITION_MS = 500 // speed of fade transition
const TRANSITION_BUFFER = 700 // extra time on top of fade to start transitioning
const SLIDE_DURATION = 5000 // duration of each slide, if there is no video

/**
 * Initialisation
 */

export function initialise() {
  $('[data-swiper="slides"]').each((i, container) => {
    createSwiper(container)
  })
}

function loadSwiper() {
  return import(/* webpackChunkName: "Swiper" */ 'swiper/dist/js/swiper.js')
}

function createSwiper(container) {
  loadSwiper().then(({ default: Swiper }) => {
    const swiper = new Swiper(container, {
      effect: 'fade',
      fadeEffect: { crossFade: true },
      speed: TRANSITION_MS,
      slidesPerView: 1,
      pagination: { el: '[data-swiper-pagination]', clickable: true },
      autoplay: {
        delay: SLIDE_DURATION,
      },
    })

    swiper.on('slideChange', initSlide)
    swiper.on('slideChange', updateNavigationIndicator)

    initSlide()
    navigation()

    function initSlide() {
      const activeIndex = swiper.activeIndex
      $(`[data-swiper-navigation-slide-number]`, container).removeClass('active')
      $(`[data-swiper-navigation-slide-number="${activeIndex}"]`, container).addClass('active')

      const slide = swiper.slides[activeIndex]
      const video = $('video', slide).get(0)
      if (video) {
        video.currentTime = 0
        video.play()
        video.loop = false
        video.addEventListener('timeupdate', function timeupdate() {
          if (swiper.activeIndex !== activeIndex) {
            video.removeEventListener('timeupdate', timeupdate)
            return
          }
          if (video.duration - video.currentTime < (TRANSITION_MS + TRANSITION_BUFFER) / 1000) {
            video.removeEventListener('timeupdate', timeupdate)
            swiper.slideTo((swiper.activeIndex + 1) % swiper.slides.length)
          }
        })
      }
    }

    function navigation() {
      $('[data-swiper-navigation] a').on('click', (event) => {
        event.preventDefault()
        const index = $(event.currentTarget).index() - 1
        swiper.slideTo(index)
      })
    }

    function updateNavigationIndicator() {
      const x = swiper.activeIndex * 100
      $('[data-swiper-navigation-indicator]', container).css({ transform: `translateX(${x}%)` })
    }
  })
}
